import { RootStore, StakingStore } from 'bzx-common/src/stores'
import Dao from 'bzx-common/src/stores/StakingStore/Dao'
import * as mobx from 'mobx'
import { DialogVM } from 'ui-framework'
import { isAddress } from 'web3-utils'

type DaoSection = 'snapshotProposals' | 'onchainProposals'

interface IDaoVMProps {
  inputDelegate: string
  daoSection: DaoSection
}

export default class DaoVM implements IDaoVMProps {
  rootStore: RootStore
  stakingStore: StakingStore
  dao: Dao
  stopAutoSyncData?: mobx.Lambda
  inputDelegate = ''
  daoSection: DaoSection = 'snapshotProposals'

  get canDelegate() {
    const { walletAddress, isConnected } = this.rootStore.web3Connection
    return isConnected && isAddress(this.inputDelegate) && this.inputDelegate !== walletAddress
  }

  get proposals() {
    return this.dao.snapshotProposals.map((proposal) => ({
      dialogVM: new DialogVM({ id: `proposal-${proposal.id}` }),
      data: proposal,
    }))
  }

  /**
   * Helper to set values through mobx actions.
   */
  set(prop: keyof IDaoVMProps, value: any) {
    ;(this[prop] as any) = value
  }

  /**
   * Helper to assign multiple props values through a mobx action.
   */
  assign(props: Partial<IDaoVMProps>) {
    Object.assign(this, props)
  }

  setDelegate(event: React.FormEvent<HTMLFormElement>) {
    event.preventDefault()
    this.dao.setDelegate(this.inputDelegate)
  }

  setSection(section: DaoSection) {
    this.daoSection = section
  }

  init() {
    setTimeout(async () => {
      this.dao.set('autoSyncData', true)
      await this.dao.getSnapshotProposals()
      await this.dao.getOnchainProposals()
    }, 0)
  }

  destroyVM() {
    this.dao.set('autoSyncData', false)
  }

  constructor({ rootStore }: { rootStore: RootStore }) {
    this.rootStore = rootStore
    this.stakingStore = rootStore.stakingStore
    this.dao = this.stakingStore.dao
    mobx.makeAutoObservable(this, undefined, { autoBind: true, deep: false })
    this.init()
  }
}
